import { Component, OnInit } from '@angular/core';
import { AppService } from '../../services/app.service';
import { environment } from 'projects/environments/environment';
import { AuthStateService } from '../../services/auth-state.service';
import { AuthUserModel } from 'projects/core/src/lib/models/authuser.model';

@Component({
  selector: 'app-splash-screen',
  templateUrl: './splash-screen.component.html',
  styleUrls: ['./splash-screen.component.scss']
})
export class SplashScreenComponent implements OnInit {

  public version = environment.version;
  public name: string | null = null;

  constructor(
    private auth: AuthStateService,
    public app: AppService,
  ) { }

  ngOnInit(): void {
    this.auth.user$.subscribe((user: AuthUserModel) => {
      this.name = user?.fullname || null;
    });
  }

}
